import { useBooksContext } from './BooksProvider';

export default useBooksContext;
